module.exports = function () {
  return {
    $get: [function () {
      function parseQrCode(str) {
        console.log('parseQr Begin')
        // login pattern
        let pattern = /^(cmauth|optauth):\/\/(qr|totp)\/(\w+)$/i
        if (pattern.test(str)) {
          const tag = RegExp.$1
          const sid = RegExp.$3
          return {
            tag: tag,
            type: 'login',
            sid: sid
          }
        }

        // bind pattern : 3 patterns:
        // 1. cm-otpauth://test@test.com?secret=G6B3DBM3KEFMIDNDBHQE52VIQ2LGG7NS&issuer=Coremail&algorithm=SHA1&digits6&period=30
        // 2. otpauth://test@test.com?secret=G6B3DBM3KEFMIDNDBHQE52VIQ2LGG7NS&issuer=Coremail&algorithm=SHA1&digits=6&period=30"
        // 3. cm-otpauth://user1%40mflai.com?secret=THLQZ6LUKSWTXHY2DVVHDXK3SHU4DLA5&issuer=Coremail
        pattern = /(cm-otpauth:\/\/|otpauth:\/\/totp\/Coremail:)(\w+%40\w+\.\w+)\?(.+)/i
        const patternShort = /(cm-otpauth:\/\/|otpauth:\/\/)(\w+%40\w+\.\w+)\?(.+)/i
        if (pattern.test(str) || patternShort.test(str)) {
          const email = RegExp.$2
          const paramsStr = RegExp.$3
          const tempArr = paramsStr.split('&')
          const result = {
            type: 'bind',
            email: email,
            params: {}
          }
          tempArr.forEach(function (ele) {
            const arr = ele.split('=')
            result.params[arr[0]] = arr[1]
          })
          return result
        }
        // external link
        pattern = /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/g
        if (pattern.test(str)) {
          return {
            type: 'extLink',
            url: str
          }
        }
        return null
      }

      return {
        parseQrCode: parseQrCode
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/qr.js